import { render, staticRenderFns } from "./SoftwareSubscriptions.vue?vue&type=template&id=3b534ab9&scoped=true"
import script from "./SoftwareSubscriptions.vue?vue&type=script&lang=js"
export * from "./SoftwareSubscriptions.vue?vue&type=script&lang=js"
import style0 from "./SoftwareSubscriptions.vue?vue&type=style&index=0&id=3b534ab9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b534ab9",
  null
  
)

export default component.exports